// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'futuraPTProDemi', 'futuraPTProDemi Fallback'"},"className":"__className_ac924e","variable":"__variable_ac924e"};